<template>
  <div class="login-container">
      <div class="top-part">
      </div>
      <div class="middle-part">
        <div class="login-form-container" >
          <p>账号登录</p>
          <el-form class="login-form first" :model="loginForm" ref="loginForm">
            <el-form-item prop="phoneNumber">
              <svg-icon icon-class="login" class="icon-opera"></svg-icon>
              <el-input placeholder="请输入账号名" v-model="loginForm.phoneNumber" ></el-input>
            </el-form-item>
            <el-form-item prop="password">
              <svg-icon icon-class="password" class="icon-opera"></svg-icon>
              <el-input type="password"  placeholder="请输入密码" v-model="loginForm.password"></el-input>
            </el-form-item>
            <el-form-item class="login-button">
              <el-button native-type="submit" style="width:100%" type="primary" @click.prevent="userLogin('loginForm')">登录</el-button>
            </el-form-item>
          </el-form>
        </div>
      </div>
      <div class="bottom-part">
        <span>苏州优而美网络科技有限公司</span>
        <span>版权所有&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<a href="http://beian.miit.gov.cn/" target=_blank>苏ICP备2020065257号</a></span>
      </div>
  </div>
</template>

<script>
import { myGet,login } from "@/api/http";
import {MessageBox} from 'element-ui'

export default {
  data() {
    return {
      loginForm:{
        phoneNumber: '',
        password: '',
      }
    };
  },
  created() {
    sessionStorage.removeItem('Token')
    sessionStorage.setItem('isLogin',false)
  },
  methods: {
    // 登录
    userLogin(formName) {
      this.$refs[formName].validate((valid) => {
        if(valid) {
          login(
            '/auth/login',
            {
              account: this.loginForm.phoneNumber,
              password: this.loginForm.password
            }
          )
          .then(res => {
            if(res.data.code == 200){
              // 将唯一标识储存起来
              sessionStorage.setItem('Token', res.data.data);
              //是否登录判断标识
              sessionStorage.setItem('isLogin',true)
              myGet('/auth/userInfo')
              .then(res => {
                sessionStorage.setItem('accountInfo', JSON.stringify(res.data.data))
                this.$router.push({ path: "/directlyCustomer" });
              })
            }
            else {
              this.$alert(res.data.message)
            }
          })
          .catch(err => {
            this.$alert('用户名或者密码错误')
          });
        }
      }) 

    },
  }

};
</script>

<style scoped>
  .login-container {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    width: 100%;
    height: 100%;
    padding: 30px 0 20px;
    box-sizing: border-box;
    background: url('../../assets/image/loginbg.png') no-repeat top left;
    background-size: cover;
  }
  .top-part {
    text-align: center;
    color: #fff;
  }
  .top-part span {
    padding-left: 20px;
    font-size: 20px;
  }
  .middle-part {
    display: flex;
    justify-content: flex-end;
    padding-right: 100px;
  }
  .login-form-container {
    /* position: relative; */
    background-color: #fff;
    z-index: 999;
    width: 400px;
    padding: 30px;
    box-sizing: border-box;
    box-shadow: 0px 30px 30px 0px rgba(0, 0, 0, 0.5);
  }
  .bottom-part {
    font-size: 12px;
    color: #fff;
    display: flex;
    flex-direction: column;
    align-items: center;
  }
  .bottom-part span {
    line-height: 20px;
  }
  .login-button {
    margin-top: 65px;
  }
  p {
    text-align: center;
    font-weight: 600;
    color: #0462BA;
  }
</style>
<style>
  .login-container .first .el-input__inner {
    border-left: 0px solid #fff;
    border-right: 0px solid #fff;
    border-top: 0px solid #fff;
    border-bottom: 1px solid #e5e5e5;
    border-radius: 0px;
  }
  .login-container .el-form-item__content {
    display: flex;
    align-items: center;
  }
</style>


// WEBPACK FOOTER //
// src/components/login/login.vue